var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab-view"},[_c('AppAttachmentsCard',{attrs:{"attachmentList":_vm.attachmentList,"masterId":Number(_vm.accountAsset.id),"masterType":"ACCOUNT_ASSET","unFolding":true},on:{"success":_vm.onSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }